import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <title>页面未找到 - 404 | 爆瓜福利</title>
      <meta name="robots" content="noindex, follow" />
      <SiteHeader />
      <main className="mx-auto flex min-h-[70vh] w-full max-w-3xl flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <p className="font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</p>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这一页没瓜可吃</h1>
        <p className="mt-3 text-sm leading-7 text-foreground-600">
          你访问的地址可能已经失效，或者链接输入有误。
          <span className="mt-1 block font-mono text-xs text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/gossip"
            className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            去逛吃瓜广场
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}